import { openBlock as n, createElementBlock as i, normalizeClass as o, renderSlot as u } from "vue";
import { _ as s } from "../_plugin-vue_export-helper-dad06003.js";
import { w as f } from "../util-b2b0dc25.js";
const r = {
  name: "rButton",
  props: {
    /**
     * 颜色类型：default | primary | info | success | warning | error
     */
    type: {
      type: String,
      default: "default"
    },
    /**
     * 幽灵按钮
     */
    ghost: {
      type: Boolean,
      default: !1
    },
    /**
     * 虚线按钮
     */
    dashed: {
      type: Boolean,
      default: !1
    },
    /**
     * 最大圆角
     */
    circle: {
      type: Boolean,
      default: !1
    },
    /**
     * 禁用
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * 尺寸: lg | nm | sm
     */
    size: {
      type: String,
      default: "nm"
    },
    /**
     * 轻淡一点
     */
    lite: {
      type: Boolean,
      default: !1
    },
    /**
     * 更轻淡一点
     */
    liter: {
      type: Boolean,
      default: !1
    },
    /**
     * 链接形态
     */
    link: {
      type: Boolean,
      default: !1
    },
    /**
     * 链接地址
     */
    href: {
      type: String,
      default: ""
    }
  },
  emits: {
    /**
     * 点击
     */
    click: null
  },
  methods: {
    handleClick(e) {
      this.disabled || this.$emit("click", e);
    }
  }
}, c = ["href"];
function b(e, l, t, y, m, a) {
  return t.link ? (n(), i("a", {
    key: 0,
    href: t.href,
    class: o(["r-button r-button-link", {
      [`r-button-${t.type}`]: t.type,
      [`r-button-${t.size}`]: t.size !== "default"
    }])
  }, [
    u(e.$slots, "default")
  ], 10, c)) : (n(), i(
    "button",
    {
      key: 1,
      class: o(["r-button", {
        [`r-button-${t.type}`]: t.type,
        "r-button-circle": t.circle,
        "r-button-disabled": t.disabled,
        "r-button-ghost": t.ghost,
        "r-button-dashed": t.dashed,
        "r-button-lite": t.lite,
        "r-button-liter": t.liter,
        [`r-button-${t.size}`]: t.size !== "default"
      }]),
      onClick: l[0] || (l[0] = (...d) => a.handleClick && a.handleClick(...d))
    },
    [
      u(e.$slots, "default")
    ],
    2
    /* CLASS */
  ));
}
const h = /* @__PURE__ */ s(r, [["render", b], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/button/button.vue"]]), g = f(h);
export {
  g as default
};
